import ImageCardGrid from "../common/WhyImageCard";

/* ── Main Component ── */
const WhoThisIsForCards = ({
    section,
}) => {
    if (!section) return null;

    const { items = [] } = section;

    return (
        <div className="flex flex-col  p-4 md:px-10 ">
            <h2 className=" ava-heading-md text-center">
                Who This Is For
            </h2>
            {/* <div className="flex flex-wrap justify-center lg:justify-center gap-6"> */}
                {/* {items.map((item, index) => (
                    <div key={item.id || index}>
                        <ImageCardGrid item={item} />
                    </div>
                ))} */}
                <ImageCardGrid data={section}/>
            {/* </div> */}
        </div>
    );
};

export default WhoThisIsForCards;

/* ── Card Component ── */
export const ServiceCard = ({ item }) => {
    return (
        <div className="bg-white shadow-sm rounded-[10px]  flex flex-col overflow-hidden w-[260px] h-[284px] my-5">
            {/* Image */}
            <div className="">
                <img
                    src={item.image}
                    alt={item.label || item.title}
                    className="w-full object-cover transition-transform duration-500 h-[200px] rounded"
                />
                {/* ✅ Label ONLY if exists */}
                {/* {item.imgicon && (
          <div className="absolute top-0 left-0 flex items-center gap-2 px-3 py-3 bg-white text-white text-xs rounded-br-[10px]">
            <img src={item.imgicon} alt="" className=""  />
            <span>{item.label}</span>
          </div>
        )} */}
            </div>

            {/* Content */}
            <div className="w-full px-4 py-4 ava-card-bg flex flex-col justify-start flex-1" >
                <p
                    className="ava-text-subheading  md:pl-3"
                    >
                    {item.description}
                </p>
            </div>
        </div>
    );
};